import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ValueProps } from '../components/ValueProps';
import { FamilyCaregiverSection } from '../components/FamilyCaregiverSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { CTABanner } from '../components/CTABanner';
import { SEO } from '../components/SEO';
export function HomePage() {
  return <main data-id="element-386">
      <SEO title="Home Care & Paid Family Caregiver Model" description="Ambient Solutions LLC helps families hire, train, and certify their own loved ones as paid professional caregivers in Columbia, MD. Get started in 24-48 hours." keywords="family caregiver, paid family caregiving, home health care Columbia MD, hire family member as caregiver" data-id="element-387" />
      <HeroSection data-id="element-388" />
      <ValueProps data-id="element-389" />
      <FamilyCaregiverSection data-id="element-390" />
      <TestimonialsSection data-id="element-391" />
      <CTABanner data-id="element-392" />
    </main>;
}